<div class="modal-container main-font">
  <div class="modal-content-container">
    <div class="modal-header-container">
      <div class="title-container mb-4">
        <p class="modal-title mb-0">Nuova richiesta di malattia</p>
      </div>
      <hr />
    </div>

    <div class="modal-content">
      <form class="form-container" [formGroup]="sicknessForm">
        <div class="date-content row">
          <p class="text mb-0 pb-0 d-flex align-items-center">
            <img
              src="../../../../../../../assets/images/icon_request_modal/calendar.svg"
              alt="" />
            {{ sicknessForm.get('date')?.value }}
          </p>
        </div>
        <div class="note-container row">
          <p class="m-0 p-0 text-nate">Contenuto della mail di richiesta</p>
          <nz-textarea-count [nzMaxCharacterCount]="250">
            <textarea
              class="w-100"
              [nzAutosize]="{ minRows: 3, maxRows: 3 }"
              formControlName="notes"
              nz-input
              (input)="limitTextLength()"
              placeholder="Scrivi il corpo dell'email">
            </textarea>
          </nz-textarea-count>
        </div>
      </form>
    </div>
    <div class="modal-footer-container">
      <button class="primary-btn-outline-new w-100" (click)="closeModal()">
        Annulla
      </button>
      <button
        class="primary-btn-new w-100"
        [disabled]="sicknessForm.invalid"
        (click)="saveSicknessRequest()">
        {{ 'Invia' }}
      </button>
    </div>
  </div>
</div>
